import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { General } from "../../siteManagement/general";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { SheetEventType } from "../../siteManagement/sheet";
import { Grid } from "../core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import EditFieldApp, { IndividualField, EditFieldProps, SelectionType } from "./editField";
import { IndividualFieldDropDown } from "./individualFieldDropDown";
import React from "react";
export default class IndividualFieldsGrids extends React.Component<any, { isUnicode: boolean }> {
    private tableInfoRef: TableInfo;
    private url: string;
    constructor(props) {
        super(props);
        this.state = {
            isUnicode: true
        }
        this.url = props.url;
        this.initApp();
    }

    private initApp = async () => {
        const result = await HTTPService.get<JsonResultClass<boolean>>("EditIndividualFields/IsUnicode");
        this.setState({ isUnicode: result.Code == 0 && result.Data })
    }

    private onSelectChange = (tableName: string) => {
        this.tableInfoRef.setTableName(tableName);
    }

    render() {
        return (
            <div className="flex-container">
                <IndividualFieldDropDown onSelectChange={this.onSelectChange} translations={this.props.context.translations} url={this.url} />
                <TableInfo ref={(ref) => { this.tableInfoRef = ref }} translations={this.props.context.translations} isUniCode={this.state.isUnicode} />
            </div>
        );
    }

}

class TableInfo extends React.Component<{ translations: {}, isUniCode: boolean }, TableInfoState>{
    private gridOptions: kendo.ui.GridOptions;
    private primaryKeyColors = {
        backgroundColor: "#ef5350",
        fontColor: "#ffffff"
    }
    constructor(props) {
        super(props);
        this.initApp();
        this.state = {
            gridData: [],
            tableName: null,
            selected: null
        }
    }

    setTableName = (tableName: string) => {
        this.setState({ tableName: tableName }, this.loadGridData);
    }

    private initApp = () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: true,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "Ordinal",
                    title: this.props.translations["WebCRM.EditIndividualFields.Ordinal"]
                },
                {
                    field: "ColumnName",
                    title: this.props.translations["WebCRM.EditIndividualFields.ColumnName"]
                },
                {
                    field: "DataType",
                    title: this.props.translations["WebSMS.Report.Question.Search.Datentyp"]
                },
                {
                    field: "Mandatory",
                    title: this.props.translations["WebCRM.EditIndividualFields.Mandatory"],
                    width: 12,
                    template: "# if(data.Mandatory) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#"
                },
                {
                    field: "SelectionTypeName",
                    title: Helper.getTranslation("WebCRM.EditIndividualFields.SelectionType")
                }
            ]
        };
    }

    private loadGridData = async () => {
        let url = "EditIndividualFields/GetIndividualFields?tableName=" + this.state.tableName;
        const result = await HTTPService.get<JsonResultClass<[]>>(url);
        if (result.Code === 0) {
            this.setState({ gridData: result.Data });
        }
    }

    private createGrid = () => {
        let standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true },
            { type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: Helper.hasValue(this.state.selected) && !this.state.selected.IsPrimaryKey },
            { type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: Helper.hasValue(this.state.selected) && !this.state.selected.IsPrimaryKey }
        ];
        return (
            <div className="flex-container">
                <Grid
                    standardButtons={standardButtons}
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="tableInfoIndividualFieldsGrid"
                    onClickStandardButton={this.onButtonClick}
                    onSelectionChanged={(dataItem) => { this.setState({ selected: dataItem }) }}
                    onDataBound={this.handleDataBound}
                />
            </div>
        );
    }

    private onButtonClick = async (type: ToolBarStandardButtonType, dataItem: IndividualField) => {
        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                this.openEdit(dataItem);
                break;
            case ToolBarStandardButtonType.NEW:
                this.openEdit();
                break;
            case ToolBarStandardButtonType.DELETE:
                const isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
                if (isOk) {
                    let result = await HTTPService.get<JsonResultClass>("EditIndividualFields/DeleteColumn", dataItem);
                    if (result.Code === 0) {
                        NotificationHelper.showSuccessMessage(result.Message);
                        this.loadGridData();
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                }
                break;
        }
    }

    private handleDataBound = (e) => {
        let data = e.sender.dataSource.view();
        for (var i = 0; i < data.length; i++) {
            if (data[i].IsPrimaryKey) {
                let row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                let cell = $("td", row);
                cell.css("background-color", this.primaryKeyColors.backgroundColor);
                cell.css("color", this.primaryKeyColors.fontColor);
            }
        }
    }

    private openEdit = async (dataItem: IndividualField = null) => {
        let isNew = dataItem == null;
        if (isNew) {
            let item: IndividualField = {
                ColumnName: this.state.tableName + "_",
                DataTable: null,
                DataType: null,
                Designation: null,
                Mandatory: false,
                MaxLenght: -1,
                Ordinal: (this.state.gridData.length + 1),
                SelectionType: SelectionType.EditBox,
                TableName: this.state.tableName,
                IsPrimaryKey: false,
                Translations: [],
                IsNew: true,
                IsWatchable: false,
                IsWatched: false,
                RecordRight: {
                    CanRead: true,
                    CanWrite: true
                },
                IndividualFields: null,
                OrderByField: null
            }
            let entity = item as any;
            entity.IsNew = true;
            entity.IsWatchable = false;
            entity.IsWatched = false;
            entity.RecordRight = {
                CanRead: true,
                CanWrite: true
            };
            this.openSheet(entity);
        } else {
            const result = await HTTPService.get<JsonResultClass<[]>>(`EditIndividualFields/LoadTranslation?table=${dataItem.TableName}&column=${dataItem.ColumnName}`);
            const entity: IndividualField = JSON.parse(JSON.stringify(dataItem));
            entity.IsNew = false;
            entity.IsWatchable = false;
            entity.IsWatched = false;
            entity.RecordRight = {
                CanRead: true,
                CanWrite: !dataItem.IsPrimaryKey
            };
            entity.Translations = result.Data;
            this.openSheet(entity);
        }
    }

    private openSheet = async (entity) => {
        const metaData = await Helper.getMetaData("field");
        const props: EditFieldProps = {
            context: {
                contextType: "editField",
                isUniCode: this.props.isUniCode
            },
            title: "",
            metadata: metaData,
            entity: entity,
            dataSources: {},
            isWindow: false
        };
        let sheet = General.Sheet.Manager.createSheet()
        sheet.show(() => {
            sheet.mountContent(EditFieldApp, props);
        });
        sheet.bind(SheetEventType.SavedSuccessfully, () => { this.loadGridData() })
    }

    render() {
        return !Helper.isNullOrEmpty(this.state.tableName) ? this.createGrid() : null;
    }

}

interface TableInfoState {
    tableName: string;
    gridData: IndividualField[];
    selected: IndividualField;
}
